import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import auth from '@react-native-firebase/auth';
import SplashScreen from 'react-native-splash-screen';
import Theme from '../theme';
import { LoadingModal } from '../ui';
import { clearDeepLinkParams, Storage } from '../utils';
import { preAuthRouteSelector, shouldNavigateToSocialAuthLoadingSelector } from './auth-selectors';
import { Logger } from '../utils/Logger';

class AuthLoadingScreen extends Component {

  constructor(props) {
    super(props);
    Logger.leaveBreadcrumb('AuthLoadingScreen');

    this.state = {
      isLoading: true,
    };
  }

  componentDidMount = async () => {
    SplashScreen.hide();
    await auth().onAuthStateChanged(async (user) => {
      if (user) {
        return;
      }

      const willNavigate = this.navigateToBasicDetailsIfContinueTokenIsPresent();
      if (willNavigate) {
        return;
      }

      Logger.debug('[AuthLoadingScreen] no user details');
      let redirectRoute = await Storage.get('signoutRoute');

      // :shrug:
      if (redirectRoute === '[object Object]') {
        await Storage.remove('signoutRoute');
        redirectRoute = undefined;
      }

      this.navigateTo(`${redirectRoute || 'AuthNavigator'}`);
    });

    // todo: the flow here looks weird:
    //  if willNavigate is true, should it not also block this second
    //  onAuthStateChanged listener? (and have the navigated-to screen navigate
    //  back to AuthLoadingScreen - as handleOnCompleteSocialAuth does
    const unsubscribe = await auth().onAuthStateChanged(async (user) => {
      if (unsubscribe) {
        unsubscribe();
      }

      if (!user) {
        return;
      }

      if (this.props.loginWithToken) {
        Logger.debug('[AuthLoadingScreen] signed in using auth tokens (off screen). navigation will complete via onSuccess->handleOnCompleteSocialAuth->another AuthLoadingScreen');
        return;
      }

      if (this.props.shouldNavigateToSocialAuthLoading) {
        this.props.clearDeepLinkParams(['type', 'providerId']);
        return this.navigateTo('SocialAuthLoading');
      }

      Logger.debug('[AuthLoadingScreen] launching HomeNavigator');
      this.navigateTo('HomeNavigator');
    });
  };

  navigateTo = (route) => {
    this.setState({
      isLoading: false,
    });
    this.props.navigation.navigate(route);
  };

  navigateToBasicDetailsIfContinueTokenIsPresent = () => {
    const { navigateToRoute } = this.props;

    if (navigateToRoute) {
      this.navigateTo(navigateToRoute);
      return true;
    }
    return false;
  }


  render() {
    return (
      <View style={styles.container}>
        <LoadingModal isLoading={this.state.isLoading} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    minHeight: '100%',
    backgroundColor: Theme.WHITE,
  },
});

const mapStateToProps = (state) => ({
    shouldNavigateToSocialAuthLoading: shouldNavigateToSocialAuthLoadingSelector(state),
    navigateToRoute: preAuthRouteSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  clearDeepLinkParams: (params) => dispatch(clearDeepLinkParams(params))
})

export default connect(mapStateToProps, mapDispatchToProps)(AuthLoadingScreen);
